import clsx from 'clsx'
import {FC, useState} from 'react'
import {Link} from 'react-router-dom'
import {useLayout, usePageData} from '../../../core'
import {BottomSheet} from 'react-spring-bottom-sheet'
import {useIntl} from 'react-intl'
import 'react-spring-bottom-sheet/dist/style.css'
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons'
import FAIcon from '../../../../helpers/components/FAIcon'

const CustomTitle: FC = () => {
  const {pageTitle, pageDescription, pageBreadcrumbs, pageModuleName} = usePageData()
  const {config, classes} = useLayout()
  const [open, setOpen] = useState(false)
  const intl = useIntl()
  const msgTitle = intl.formatMessage({id: `PURPOSE.${pageModuleName}.TITLE`})
  const msgDesc = intl.formatMessage({id: `PURPOSE.${pageModuleName}.DESCRIPTION`})

  return (
    <div
      id='kt_page_title'
      data-kt-swapper-mode='prepend'
      data-kt-swapper-parent="{default: '#kt_toolbar_container'}"
      className={clsx(
        'page-title d-flex w-100 justify-content-between',
        classes.pageTitle.join(' ')
      )}
    >
      {pageTitle && (
        <h1 className='d-flex align-items-center text-dark fw-bolder my-1 fs-3'>
          {pageTitle}
          {pageModuleName && (
            <FAIcon
              icon={faInfoCircle}
              className='ms-4 cursor-pointer page-info-icon'
              onClick={() => setOpen(true)}
            />
          )}
          {pageDescription && config.pageTitle && config.pageTitle.description && (
            <>
              <span className='h-20px border-gray-200 border-start ms-3 mx-2' />
              <small className='text-muted fs-7 fw-bold my-1 ms-1'>{pageDescription}</small>
            </>
          )}
        </h1>
      )}
      {pageBreadcrumbs &&
        pageBreadcrumbs.length > 0 &&
        config.pageTitle &&
        config.pageTitle.breadCrumbs && (
          <>
            <ul className='breadcrumb fw-bold fs-7 my-1 text-uppercase'>
              {Array.from(pageBreadcrumbs).map((item, index) => (
                <li
                  className={clsx('breadcrumb-item', {
                    'text-dark': !item.isSeparator && item.isActive,
                    'text-muted': !item.isSeparator && !item.isActive,
                  })}
                  key={`${item.path}${index}`}
                >
                  {!item.isSeparator ? (
                    <Link
                      className='text-muted text-hover-primary'
                      to={item.path}
                      state={item?.state}
                    >
                      {item.title}
                    </Link>
                  ) : (
                    <span className='bullet bg-gray-200 w-5px h-2px' />
                  )}
                </li>
              ))}
              <li className='breadcrumb-item text-dark'>{pageTitle}</li>
            </ul>
          </>
        )}
      {pageModuleName && (
        <BottomSheet
          open={open}
          style={{zIndex: 99999}}
          onDismiss={() => setOpen(false)}
          className='bottom-sheet'
        >
          <div className='my-10 text-center px-6'>
            <h1 className='mb-8'>
              {msgTitle === `PURPOSE.${pageModuleName}.TITLE` ? 'Purpose of the form' : msgTitle}
            </h1>
            <p
              className={clsx({
                'text-start': pageModuleName === 'ORDER',
                'text-center': pageModuleName !== 'ORDER',
              })}
              dangerouslySetInnerHTML={{
                __html:
                  msgDesc === `PURPOSE.${pageModuleName}.DESCRIPTION`
                    ? 'This form will help you to create the master template'
                    : msgDesc,
              }}
            />
          </div>
        </BottomSheet>
      )}
    </div>
  )
}

export {CustomTitle}
